import {
  getRoleListQueryKey,
  roleList,
  useRoleCreate,
  useRoleDelete,
  useRoleList,
  useRoleUpdate,
} from "@/api/generated/endpoints/api"

export const roleApi = {
  useRoleList,
  useRoleCreate,
  useRoleUpdate,
  useRoleDelete,
  roleList,
  getRoleListQueryKey,
}
